export default function Privacy() {
  return (
    <div className="container legal-shell">
      <div className="card">
        <h1>Privacy Policy</h1>
        <p>Effective date: April 2, 2026</p>
        <p>
          AffiTrack collects and uses limited account, workspace, and billing-related data to operate the service across
          the web app and mobile app.
        </p>

        <h2>Information We Collect</h2>
        <p>Depending on how you use AffiTrack, we may collect:</p>
        <p>
          Account information such as your email address, username, authentication records, and workspace membership.
        </p>
        <p>
          Workspace and user-generated content such as workspace names, content link names, content URLs, destination
          URLs, payout values, notes, invite details, and related activity needed to manage your workspace.
        </p>
        <p>
          Billing and subscription information such as plan tier, subscription status, and transaction or purchase state
          needed to provide paid features. Payment card details are processed by our payment providers and are not stored
          directly by AffiTrack.
        </p>
        <p>
          Technical and operational information needed to keep the service functioning, such as authentication state and
          app data stored in our backend systems.
        </p>

        <h2>How We Use Information</h2>
        <p>We use collected information to:</p>
        <p>Provide account access, workspace syncing, content link management, and subscription features.</p>
        <p>Maintain security, prevent fraud or abuse, and support account recovery or support requests.</p>
        <p>Process billing, verify subscription access, and keep plan entitlements in sync.</p>
        <p>Respond to account, privacy, and deletion requests.</p>

        <h2>Data Sharing</h2>
        <p>
          We do not sell personal data. We share data only with service providers that help us operate the service, such
          as infrastructure, authentication, database, hosting, and payment providers.
        </p>
        <p>
          AffiTrack currently relies on providers such as Firebase for authentication, database, hosting, and cloud
          functions, and Stripe and Google Play for payment and subscription processing where applicable.
        </p>

        <h2>Data Retention</h2>
        <p>
          We keep account and workspace data for as long as needed to provide the service, maintain security, and comply
          with legal obligations.
        </p>
        <p>
          Some limited billing, payment, tax, fraud prevention, or dispute records may be retained for the minimum period
          required by law, contract, or our payment providers even after an account deletion request is completed.
        </p>

        <h2>Data Deletion</h2>
        <p>
          You can request deletion of your AffiTrack account and associated workspace data by emailing{" "}
          <a href="mailto:support@affitrack.net">support@affitrack.net</a> from the email address on your account with
          the subject line <strong>Account Deletion Request</strong>.
        </p>
        <p>
          You can also visit the account deletion instructions page at <a href="/account-deletion">/account-deletion</a>.
        </p>

        <h2>Security</h2>
        <p>
          We use reasonable administrative, technical, and organizational measures to protect data in transit and at rest
          through our service providers, but no method of transmission or storage is completely secure.
        </p>

        <h2>Contact</h2>
        <p>
          For privacy, account, or data-related questions, contact <a href="mailto:support@affitrack.net">support@affitrack.net</a>.
        </p>
      </div>
    </div>
  );
}
